import React from 'react';

const ErrorPage = () => {
  return (
    <main
      className="main"
      style={{
        padding: '1rem',
      }}
    >
      <h1
        style={{
          margin: '1rem 1rem 1rem 4rem',
        }}
      >
        404
      </h1>
      <h3
        style={{
          padding: '1rem',
        }}
      >
        There is nothing here!
      </h3>
    </main>
  );
};
export default ErrorPage;
